import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { ThumbaCoin } from "@roman/shared/components/Icons";
import { useNavigate } from "react-router-dom";

type InsufficientModalProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
  entryFee: number;
  userPoints: number;
};
export const InsufficientModal = ({ open, setOpen, entryFee, userPoints }: InsufficientModalProps) => {
  const navigate = useNavigate();
  const lackingAmount = entryFee - userPoints;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="[&>button]:hidden py-8 w-[350px] md:w-[450px] h-[428x] border-none">
        <DialogTitle className="dialog-content text-black text-center font-Inter text-[20px] font-semibold leading-[30px] tracking-[-0.2px] max-w-[287px] mx-auto">
          保有ポイントが不足しています
        </DialogTitle>
        <div className="flex flex-col justify-center items-center">
          <div className="flex deposit-wrapper w-[85%] cursor-pointer py-2 px-4 rounded-[60px] justify-between mt-3">
            <div className="deposit-title flex items-center justify-center">
              <ThumbaCoin className="h-[24px] w-[24px]" />
              <div className="text-gray text-center font-Inter text-[16px] font-normal leading-[16px] tracking-[-0.16px] ml-2">
                必要ポイント：
              </div>
            </div>
            <div className="text-gray text-right font-Inter text-[18px] font-bold leading-[18px] tracking-[-0.18px] flex items-center">
              {entryFee}pt
            </div>
          </div>

          <div className="flex deposit-wrapper w-[85%] cursor-pointer py-2 px-4 bg-gray rounded-[60px] justify-between mt-3">
            <div className="deposit-title flex items-center justify-center">
              <ThumbaCoin className="h-[24px] w-[24px]" />
              <div className="text-gray text-center font-Inter text-[16px] font-normal leading-[16px] tracking-[-0.16px] ml-2">
                保有ポイント：
              </div>
            </div>
            <div className="text-gray text-right font-Inter text-[18px] font-bold leading-[18px] tracking-[-0.18px] flex items-center">
              {userPoints}pt
            </div>
          </div>
        </div>

        <div className="text-red text-center text-lg font-bold">あと{lackingAmount}pt必要</div>

        <div className="flex flex-col w-full items-center justify-center mt-4">
          <Button
            className="text-lg w-full py-[25px] text-white rounded-lg font-bold bg-green hover:bg-green/90 ring-0 focus:ring-0"
            variant="default"
            onClick={() => navigate("/redeem-points")}
          >
            無料ポイントをチャージする
          </Button>
          <Button className="text-base mt-3" variant="link" onClick={() => setOpen(false)}>
            閉じる
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
